module.exports = __webpack_public_path__ + "img/ballons.d5e4ae4.png";